import React from "react"

import { Typography as MuiTypography, TypographyProps } from "@mui/material"

const TypographyComponentWithStyles = (defaultStyles: TypographyProps) => {
  const TextComponent = ({ children, ...rest }: TypographyProps) => {
    return (
      <MuiTypography {...defaultStyles} {...rest}>
        {children}
      </MuiTypography>
    )
  }

  return TextComponent
}

export const Typography = {
  Extreme: TypographyComponentWithStyles({
    fontSize: "60px",
    lineHeight: "70px",
    letterSpacing: "2px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),
  Larger: TypographyComponentWithStyles({
    fontSize: "3rem",
    lineHeight: "3rem",
    letterSpacing: "2px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),
  CardHead: TypographyComponentWithStyles({
    fontSize: "25px",
    lineHeight: "25px",
    letterSpacing: "2px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),
  Large: TypographyComponentWithStyles({
    fontSize: "1.75rem",
    lineHeight: "1.75rem",
    letterSpacing: "2px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  Heading: TypographyComponentWithStyles({
    fontSize: "1.5rem",
    lineHeight: "1.5rem",
    letterSpacing: "2px",
    fontWeight: 600,
    whiteSpace: "pre-line",
  }),

  SubHead: TypographyComponentWithStyles({
    fontSize: "1.25rem",
    lineHeight: "1.25rem",
    letterSpacing: "2px",
    fontWeight: 600,
    color: "textPrimary",
    whiteSpace: "pre-line",
  }),

  SubHeadNormal: TypographyComponentWithStyles({
    fontSize: "1.25rem",
    lineHeight: "1.25rem",
    letterSpacing: "2px",
    fontWeight: 500,
    color: "textPrimary",
    whiteSpace: "pre-line",
  }),

  Title: TypographyComponentWithStyles({
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
    fontWeight: 600,
    whiteSpace: "pre-line",
  }),

  SubTitle: TypographyComponentWithStyles({
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 600,
    whiteSpace: "pre-line",
  }),

  SubTitleNormal: TypographyComponentWithStyles({
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  Description: TypographyComponentWithStyles({
    fontSize: "0.875rem",
    lineHeight: "0.875rem",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  DetailHeading: TypographyComponentWithStyles({
    fontSize: { xs: "0.75rem", md: "0.875rem" },
    lineHeight: { xs: "0.75rem", md: "0.875rem" },
    fontWeight: 600,
    whiteSpace: "pre-line",
  }),

  Action: TypographyComponentWithStyles({
    fontSize: "0.75rem",
    lineHeight: "0.75rem",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  Caption: TypographyComponentWithStyles({
    fontSize: "0.625rem",
    lineHeight: "0.625rem",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  Stepper: TypographyComponentWithStyles({
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  InputFieldTitle: TypographyComponentWithStyles({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    color: "textPrimary",
    whiteSpace: "pre-line",
  }),

  InputFieldRequired: TypographyComponentWithStyles({
    fontSize: "10px",
    lineHeight: "16px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    whiteSpace: "pre-line",
  }),

  FileFieldDetail: TypographyComponentWithStyles({
    fontSize: "12px",
    lineHeight: "12px",
    fontWeight: 500,
    color: "textPrimary",
    fontFamily: "Noto Sans JP !important",
    whiteSpace: "pre-line",
  }),

  ButtonText: TypographyComponentWithStyles({
    lineHeight: "18px",
    color: "textPrimary",
    fontWeight: 500,
    whiteSpace: "pre-line",
  }),

  DetailText: TypographyComponentWithStyles({
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    color: "textPrimary",
    whiteSpace: "pre-line",
  }),

  ExtraSmallText: TypographyComponentWithStyles({
    fontSize: "13px",
    lineHeight: "13px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    color: "#C69989",
    whiteSpace: "pre-line",
  }),

  ValidationText: TypographyComponentWithStyles({
    fontSize: "10px",
    lineHeight: "10px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    color: "text.border",
    whiteSpace: "pre-line",
  }),

  DescriptionText: TypographyComponentWithStyles({
    fontSize: "10px",
    lineHeight: "10px",
    fontWeight: 500,
    fontFamily: "Noto Sans JP !important",
    color: "#998E8A",
    whiteSpace: "pre-line",
  }),

  SignupLogo: TypographyComponentWithStyles({
    fontSize: "50px",
    lineHeight: "60px",
    fontWeight: 700,
    fontFamily: "Noto Sans JP !important",
    color: "white",
    whiteSpace: "pre-line",
  }),
}
